var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{attrs:{"placeholder":"请输入"},on:{"change":_vm.inputSelect},nativeOn:{"click":function($event){$event.stopPropagation();return $event.target.focus()}},model:{value:(_vm.styleResTxt),callback:function ($$v) {_vm.styleResTxt=$$v},expression:"styleResTxt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }